<script>
    import {sgettext} from '../../i18n.js';
    export let row = {};

</script>

{#if !row.operations_checked}
  <span
    class="badge badge-pill"
    style="background-color:#ff0060; color:white; font-weight: bold;"
    >{sgettext('$$BYPASSED$$')}</span
  >
{/if}
